var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_94_2286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1H24V18H0V1Z",
    fill: "#1E50A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5488 6.304V7.71053H17.4899L24.0004 3.0986V1H21.0376L13.5488 6.304Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0004 1H22.519L13.5488 7.35397V7.71053H14.8967L24.0004 1.26216V1Z",
    fill: "#D22F27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.038 18H24.0004V15.9009L17.4902 11.2895H13.5488V12.6956L21.038 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9989 18V16.95L16.0073 11.2895H14.1543L23.6281 18H23.9989Z",
    fill: "#D22F27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4516 12.696V11.2895H6.51058L0 15.9014V18H2.96284L10.4516 12.696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 18H1.48142L10.4516 11.646V11.2895H9.10374L0 17.7378V18Z",
    fill: "#D22F27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.96245 1H0V3.09905L6.51019 7.71053H10.4516V6.30445L2.96245 1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1V2.04997L7.992 7.71053H9.84464L0.370839 1H0Z",
    fill: "#D22F27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.26316H24V11.7368H0V7.26316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0645 1H13.9354V18H10.0645V1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.15789H24V10.8421H0V8.15789Z",
    fill: "#D22F27"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8389 1H13.1614V18H10.8389V1Z",
    fill: "#D22F27"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_94_2286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 18,
    fill: "white",
    transform: "translate(0 0.461487)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/EN.3c926cd8814db3377d597a38b379384d.svg";
export { ForwardRef as ReactComponent };